export const getUserLocation = (callback, errorCallback) => {
  if (navigator.geolocation) {
    return navigator.geolocation.getCurrentPosition(callback, errorCallback)
  }

  return errorCallback
}